export const API = {
  // BASE_URL: "http://localhost:8002/HrManagementSystem/",
  BASE_URL: "https://papaserver.papadigitalacademy.com/HrManagementSystem/",

  //login admin
  ADMIN_LOGIN: "employee/login",

  //employee login
  EMPLOYEE_LOGIN: "employee/employeelogin",

  // employee
  EMPLOYEE_CREATE: "employee/createEmployee",
  PAGENATION_EMPLOYEE: "employee/page",
  FILTER_EMPLOYEE: "employee/filter",
  GET_ONE: "employee/",
  EMPLOYEE_UPDATE: "employee/update/",
  DELETE_EMPLOYEE: "employee/delete/",
  EMPLOYEE_LISTING: "employee/listing",

  // client
  CLIENT_CREATE: "client/createclient",
  PAGENATION_CLIENT: "client/page",
  CLIENT_UPDATE: "client/updateclient/",
  CLIENT_GET_ONE: "client/",
  CLIENT_LISTING: "client/listing",
  CLIENT_LOGIN: "client/clientlogin",

  // project
  PROJECT_CREATE: "project/createProject",
  PAGENATION_PROJECT: "project/page",
  UPDATE_PROJECT: "project/updateproject/",
  PROJECT_GET_ONE: "project/",
  PROJECT_FILTERING: "project/filter",
  //employee project
  PROJECT_LIST_EMPLOYEE: "project/filter",

  // task in a project
  TASK_IN_PROJECT: "task/Projectid",

  //task
  TASK_ONE: "task/",
  UPDATE_TASK: "task/updatetask/",
  CREATE_TASK: "task/createtask",

  // comments
  GET_ALL_COMMENTS: "comments/page",
  CREATE_COMMENTS: "comments/createComments",

  //visitors
  CREATE_VISITORS: "visitors/createvisitors",
  LIST_VISITORS: "visitors/page",
  FILTER_VISITORS: "visitors/visitors_filter",
  UPDATE_VISITORS: "visitors/updateVisitors/",
  GET_ONE_VISITORS: "visitors/",
  GET_LISTING_VISITORS: "visitors/listing",

  //telecaller_wroks
  CREATE_TELECALLER: "telecaller_wroks/createTelecaller",
  LIST_TELECALLER: "telecaller_wroks/Listpage",
  UPDATE_TELECALLER: "telecaller_wroks/updateTlecaller/",
  GET_ONE_TELECALLER: "telecaller_wroks/",

  //Leave
  CREATE_LEAVE: "leave/createLeave",
  LIST_LEAVE: "leave/Leavepage",
  GET_ONE_LEAVE: "leave/",
  UPDATE_LEAVE: "leave/updateLeave/",
  SEARCH_LEAVE: "leave/Searchpage",

  // salary or the payroll details
  CREATE_SALARY_DETAILS: "salary/createSalary",
  LIST_SALARY_DETAILS: "salary/salarypage",
  SEARCH_SALARY_DETAILS: "salary/salarysearch",
  UPDATE_SALARY_DETAILS: "salary/updatesalary/",
  GET_ONE_SALARY_DETAILS: "salary/",

  // monthly planner
  LIST_MONTHLY_PLANNER: "monthlyPlanner/monthlypalnnerpage",
  CREATE_MONTHLY_PLANNER: "monthlyPlanner/createmonthlyplanner",
  GET_ONE_MONTHLY_PLANNER: "monthlyPlanner/",
  UPDATED_MONTHLY_PLANNER: "monthlyPlanner/updateplanner/",
  SEARCH_MONTHLY_PLANNER: "monthlyPlanner/searchpalnnerpage",

  //monthly Report
  CREATE_MONTHLY_REPORT: "monthlyReport/createmonthlyReport",
  LIST_MONTHLY_REPORT: "monthlyReport/monthlyReportpage",
  GET_ONE_MONTHLY_REPORT: "monthlyReport/",
  UPDATE_MONTHLY_REPORT: "monthlyReport/updateReport/",
  SEARCH_MONTHLY_REPORT: "monthlyReport/searchReportpage",

  //invoice table
  LIST_INVOICE: "invoiceTable/page",
  CREATE_INVOICE: "invoiceTable/createInvoiceTable",
  GET_ONE_INVOICE: "invoiceTable/",
  UPDATE_INVOICE: "invoiceTable/updateInvoiceTable/",
  SEARCH_INVOICE: "invoiceTable/searchInvoiceTable",
  DELETE_INVOICE: "invoiceTable/delete/",

  //internship students details
  CREATE_INTERNSHIP_STUDENTS_DETAILS: "internship/createIntern",
  LIST_INTERNSHIP_STUDENTS_DETAILS: "internship/Internpage",
  FIND_ONE_INTERN: "internship/",
  EDIT_INTERN_DETAILS: "internship/updateIntern/",

};
